module.exports = __webpack_public_path__ + "img/null_bg.005f133b.png";